import { TransitioningDialogOverlay } from '@fs/zion-ui'
import React, { useCallback, useState } from 'react'
import { Route, RouteToParentRouter } from '@fs/zion-router'
import { useTranslation } from 'react-i18next'
import { bool } from 'prop-types'
import { InvitesProvider, useGroupPendingInvites } from '@fs/zion-tree-groups'
import CreateGroupRouteView from './_route-views/CreateGroupRouteView'
import ChangeGroupImageRouteView from './_route-views/ChangeGroupImageRouteView'
import useIsComponentMounted from '../../hooks/useIsComponentMounted'
// import OverLimitCopyOptionsRouteView from './_route-views/OverLimitCopyOptionsRouteView'

// const BUILD_FAMILY_PATH = '/build-family'
const CHANGE_GROUP_IMAGE_PATH = '/edit-image'
const CREATE_GROUP_PATH = '/create-group'
const VIEW_GROUP_PATH = '/groups'
// const OVER_LIMIT_PATH = '/over-limit'
// const INVITE_FAMILY_MEMBERS_PATH = '/invite-family-members'

export default function CustomCreateGroupOverlay({ overlay, redirectOnCreate = true }) {
  const [t] = useTranslation()
  const isComponentMountedRef = useIsComponentMounted()
  const [uploadedImage, setUploadedImage] = useState() // Used for temporary storage during create group
  const [groupValues, setGroupValues] = useState()
  const [updatedGroupDetails, setUpdatedGroupDetails] = useState({})
  const { singleUseInvites, refetchInvites } = useGroupPendingInvites({
    groupId: groupValues?.id,
    isAdmin: true,
    onlySingleUseInvites: true,
  })

  const onCreateGroup = useCallback(
    (newGroupValues, history) => {
      if (isComponentMountedRef.current) setGroupValues(newGroupValues)
      if (redirectOnCreate) history.push(`${VIEW_GROUP_PATH}/${newGroupValues.id}`)
      const doNotCloseOverlay = redirectOnCreate
      return doNotCloseOverlay
    },
    [isComponentMountedRef, redirectOnCreate]
  )

  return (
    <InvitesProvider singleUseInvites={singleUseInvites} refetchInvites={refetchInvites} groupId={groupValues?.id}>
      <TransitioningDialogOverlay
        {...overlay}
        initialLocation={CREATE_GROUP_PATH}
        minHeight={400}
        closeOnClickAway={false}
      >
        <Route exact path={CREATE_GROUP_PATH} title={t('group-overlay.heading.create-group')}>
          <CreateGroupRouteView
            changeGroupImagePath={CHANGE_GROUP_IMAGE_PATH}
            onCreateGroup={onCreateGroup}
            setUpdatedGroupDetails={setUpdatedGroupDetails}
            updatedGroupDetails={updatedGroupDetails}
            uploadedImage={uploadedImage}
            overlay={overlay}
          />
        </Route>

        {/* CREATE_GROUP -> CHANGE_GROUP */}
        <Route
          exact
          path={CHANGE_GROUP_IMAGE_PATH}
          title={t('group-overlay.heading.group-image-generic')}
          subtitle={t('group-overlay.sub-heading.max-file-size')}
        >
          <ChangeGroupImageRouteView
            onGroupImageChange={(history) => history.goBack()}
            setUploadedImage={setUploadedImage}
            uploadedImage={uploadedImage}
          />
        </Route>

        <Route path="*">
          <RouteToParentRouter />
        </Route>
      </TransitioningDialogOverlay>
    </InvitesProvider>
  )
}

CustomCreateGroupOverlay.propTypes = {
  redirectOnCreate: bool,
}
